import { IAudit } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { AuditWorkItem } from 'src/app/business/swodoc/audit-work-item';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class AuditCommandHandler extends EntityCommandHandler<IAudit> {
  protected workItem: IWorkItem<IAudit>;

  constructor(auditWorkItem: AuditWorkItem) {
    super();
    this.workItem = auditWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'AuditDto';
  }
}
